module.exports = __webpack_public_path__ + "static/media/logo-ontario.57f8adc2.svg";